import React from "react";
import { Button, Modal } from "antd";

export default function ConfirmRecalculateModal({ showConfirmRecalculateModal, setShowConfirmRecalculateModal, setConfirmRecalculate }) {
  return (
    <Modal
      open={showConfirmRecalculateModal}
      title="Confirm Recalculate"
      onCancel={() => setShowConfirmRecalculateModal(false)}
      footer={
        <div style={{ display: "flex", justifyContent: "end", alignItems: "center", gap: 10 }}>
          <Button
            style={{ border: "1px solid #6b43B5", color: "#6b43B5", padding: "10px 20px" }}
            onClick={() => setShowConfirmRecalculateModal(false)}
          >
            No
          </Button>

          <Button
            type="primary"
            onClick={() => {
              setConfirmRecalculate(true);
              setShowConfirmRecalculateModal(false);
            }}
          >
            Yes
          </Button>
        </div>
      }
    >
      <p style={{ marginBottom: 0 }}>Are you sure you want to recalculate this breakdown?</p>
      <p style={{ marginBottom: 0 }}>Your changes will be lost</p>
    </Modal>
  );
}
